import { useState } from 'react';
import Button from '@mui/material/Button';
import DownloadIcon from '@mui/icons-material/Download';
import { fetcher } from '../../common/utils/fetcher';

const toCsv = (rows) => {
    if (!rows || rows.length === 0) {
        return '';
    }

    const allKeys = Array.from(
        rows.reduce((set, row) => {
            Object.keys(row || {}).forEach((k) => set.add(k));
            return set;
        }, new Set())
    );

    const escapeCsv = (value) => {
        if (value === null || value === undefined) return '';
        const str = typeof value === 'object' ? JSON.stringify(value) : String(value);
        if (/[",\n]/.test(str)) {
            return '"' + str.replace(/"/g, '""') + '"';
        }
        return str;
    };

    const header = allKeys.join(',');
    const lines = rows.map((row) => allKeys.map((k) => escapeCsv(row[k])).join(','));
    return [header, ...lines].join('\n');
};

const downloadBlob = (content, filename, contentType) => {
    const blob = new Blob([content], { type: contentType });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
};

const DownloadPointsButton = ({ achievementId }) => {
    const [downloading, setDownloading] = useState(false);

    const handleDownload = async () => {
        if (!achievementId) return;
        setDownloading(true);
        try {
            const limit = 500;
            let offset = 0;
            let all = [];
            // Loop until fewer than limit are returned
            // Use meta to decide when to stop
            // Directus supports meta: '*'
            // fetcher returns full { data, meta } when meta is requested
            // otherwise returns the data array directly
            // We rely on length < limit to stop
            // and guard against undefined shapes
            // Also avoid infinite loops with a max iterations cap
            let iterations = 0;
            const maxIterations = 1000;

            // eslint-disable-next-line no-constant-condition
            while (true) {
                iterations += 1;
                if (iterations > maxIterations) break;

                const res = await fetcher({
                    url: 'points',
                    filter: {
                        _and: [
                            {
                                achievement: {
                                    _eq: achievementId,
                                },
                            },
                        ],
                    },
                    limit,
                    offset,
                    meta: '*',
                });

                const pageData = Array.isArray(res) ? res : (res?.data || []);

                all = all.concat(pageData);
                if (!pageData || pageData.length < limit) {
                    break;
                }
                offset += limit;
            }

            const csv = toCsv(all);
            const filename = `points_${achievementId}.csv`;
            downloadBlob(csv, filename, 'text/csv;charset=utf-8;');
        } catch (e) {
            // Optional: surface error via console
            // Keeping UI simple per request
            // eslint-disable-next-line no-console
            console.error(e);
        } finally {
            setDownloading(false);
        }
    };

    return (
        <Button
            variant="outlined"
            size="small"
            startIcon={<DownloadIcon />}
            onClick={handleDownload}
            disabled={downloading}
            sx={{ mt: 1 }}
        >
            {downloading ? 'Downloading…' : 'Download points CSV'}
        </Button>
    );
};

export default DownloadPointsButton;





